import {toString} from './toString'

export function lexCompare<T, P>(
    data1: T,
    data2: P,
    locales: string | string[] | undefined = undefined,
    options: Intl.CollatorOptions | undefined = undefined
): number {
    return toString(data1).localeCompare(toString(data2), locales, options)
}

export function caseInsensitiveStringCompare(value1: string | undefined, value2: string | undefined): number {
    value1 ||= ''
    value2 ||= ''
    return value1.toLocaleLowerCase().localeCompare(value2.toLocaleLowerCase(), undefined, {
        numeric: true
    })
}
